import { Observable } from 'rxjs';

export type ObservableAndState<T> = {
  observable: Observable<T>;
  state: T;
};

export const createObservableAndState = <T>(observable: Observable<T>, state: T) => {
  return {
    observable,
    state,
  } as ObservableAndState<T>;
};
